// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1090":"67259dd1","5335":"779c6a1c","5838":"67259dd1"}[chunkId] + ".chunk.css";
};